import { render, staticRenderFns } from "./ZLoading.vue?vue&type=template&id=2533a3e8&"
import script from "./ZLoading.vue?vue&type=script&lang=js&"
export * from "./ZLoading.vue?vue&type=script&lang=js&"
import style0 from "./ZLoading.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports